module.exports = __webpack_public_path__ + "img/img1.1e2779ca.png";